import '@assets/css/skeleton.css';

export const GymBrandDetailSkeleton = () => {
  return (
    <>
      {/* Header card */}
      <div className="card border-0 shadow-sm mt-4 overflow-hidden">
        <div className="position-relative">
          <div className="shimmer" style={{ height: 150, width: '100%' }} />
          <div className="position-absolute bottom-0 start-0 w-100 p-4">
            <div className="d-flex justify-content-between align-items-end gap-3 flex-wrap">
              <div className="d-flex align-items-end gap-3">
                <div className="shimmer rounded-circle border border-4 border-white" style={{ width: 64, height: 64 }} />
                <div>
                  <div className="d-flex gap-2 mb-2">
                    <div className="shimmer" style={{ height: 22, width: 80, borderRadius: 20 }} />
                    <div className="shimmer" style={{ height: 22, width: 80, borderRadius: 20 }} />
                  </div>
                  <div className="shimmer" style={{ height: 30, width: 200, marginBottom: 6 }} />
                  <div className="shimmer" style={{ height: 20, width: 250 }} />
                </div>
              </div>
              <div className="d-flex gap-2">
                <div className="shimmer" style={{ height: 36, width: 100, borderRadius: 4 }} />
              </div>
            </div>
          </div>
        </div>
        <div className="card-body">
          <div className="row g-3">
            {[1, 2, 3, 4].map((i) => (
              <div className="col-md-3" key={i}>
                <div className="border rounded-3 p-3">
                  <div className="shimmer" style={{ height: 14, width: '60%', marginBottom: 4 }} />
                  <div className="shimmer" style={{ height: 20, width: '70%' }} />
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Tabs skeleton */}
      <div className="mt-4">
        <ul className="nav nav-tabs border-0">
          <li className="nav-item">
            <span className="nav-link active">
              <div className="shimmer" style={{ height: 20, width: 70 }} />
            </span>
          </li>
          <li className="nav-item">
            <span className="nav-link">
              <div className="shimmer" style={{ height: 20, width: 70 }} />
            </span>
          </li>
        </ul>
        <div className="pt-3">
          {/* Branch list skeleton */}
          <div className="d-flex justify-content-end mb-3">
            <div className="shimmer" style={{ height: 36, width: 120, borderRadius: 4 }} />
          </div>
          <div className="row">
            {[1, 2, 3, 4].map((i) => (
              <div className="col-xl-3 col-lg-6 mt-4" key={i}>
                <div className="card border-0 shadow-sm h-100 overflow-hidden">
                  <div className="position-relative">
                    <div className="shimmer" style={{ height: 160, width: '100%' }} />
                    <div className="position-absolute top-0 end-0 m-2">
                      <div className="shimmer" style={{ height: 28, width: 80, borderRadius: 20 }} />
                    </div>
                    <div className="position-absolute" style={{ left: 16, bottom: -28 }}>
                      <div className="shimmer rounded-circle" style={{ width: 64, height: 64 }} />
                    </div>
                  </div>
                  <div className="card-body pt-4">
                    <div className="shimmer" style={{ height: 24, width: '70%', marginBottom: 8 }} />
                    <div className="shimmer" style={{ height: 18, width: '80%', marginBottom: 8 }} />
                    <div className="shimmer" style={{ height: 18, width: '50%', marginBottom: 12 }} />
                    <div className="d-flex flex-wrap gap-1">
                      <div className="shimmer" style={{ height: 24, width: 60, borderRadius: 20 }} />
                      <div className="shimmer" style={{ height: 24, width: 60, borderRadius: 20 }} />
                    </div>
                  </div>
                  <div className="card-footer bg-transparent border-0">
                    <div className="shimmer" style={{ height: 16, width: '60%' }} />
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};